// /Components/Admin/Credit/CreditTabs.jsx
import { useState } from "react";
import { Users, Landmark } from "lucide-react";
import CustomerUdhaariTable from "./CustomerUdhaariTable";
import VendorManager from "./VendorManager";
import "./CreditStyle.css";
import OrderInvoices from "./OrderInvoices";

export default function CreditTabs({ userID }) {
  const [tab, setTab] = useState("UDHAARI"); // "UDHAARI" | "VENDOR"

  return (
    <div className="admin-credit-wrap p-4">
      <div className="admin-credit-header">
        <div>
          <h3 className="admin-credit-title">Credit & Vendors</h3>
          <p className="admin-credit-subtitle">Manage customer udhaari and vendor directory/dues.</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="admin-tabs">
        <button
          className={`admin-tab ${tab === "UDHAARI" ? "active" : ""}`}
          onClick={() => setTab("UDHAARI")}
        >
          <Users size={16} /> Udhaari
        </button>
        <button
          className={`admin-tab ${tab === "VENDOR" ? "active" : ""}`}
          onClick={() => setTab("VENDOR")}
        >
          <Landmark size={16} /> Invoices
        </button>
      </div>

      {tab === "UDHAARI" ? (
        <CustomerUdhaariTable userID={userID} />
      ) : tab === "VENDOR" ? <OrderInvoices userID={userID}/> :(
        // <VendorManager userID={userID} />
        <>More Tabs Will Be Heres</>
      )}
    </div>
  );
}
